module.exports = __webpack_public_path__ + "static/media/g-modal-close.e2005cee.svg";